import {css} from "lit";

export const typo3Style = css`

/* Special Styling for external Links in Typo3 */
    :host(.externalLink), :host(.externalLinkIcon) {
        div.link-wrapper {
            display: inline-block;
        }

        sbk-icon {
            display: inline-flex;
            position: relative;
            vertical-align: text-bottom;
        }

        .link {
            display: inline-block;
        }
    }
`;